import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import { GUESTGET, httpOk, resolveUploadUrl } from 'helpers/api'

function Site() {
	const { slug } = useParams()
	const [config, setConfig] = useState(null)
	const [menu, setMenu] = useState([])

	async function load() {
		const configResponse = await GUESTGET(`/website/config/${slug}`, {}, { loader: true })
		if (!httpOk(configResponse)) return

		setConfig(configResponse.data)

		const externalMenuId = configResponse.data.external_menu_id
		if (externalMenuId) {
			const menuResponse = await GUESTGET(`/website/external-menu/${externalMenuId}`)
			if (httpOk(menuResponse)) {
				setMenu(menuResponse.data?.menu ?? menuResponse.data?.categories ?? menuResponse.data ?? [])
			}
			return
		}

		const defaultPos = configResponse.data.poses?.find(pos => pos.is_default) ?? configResponse.data.poses?.[0]
		const posId = defaultPos?.id
		if (!posId) return

		const menuResponse = await GUESTGET(`/website/menu/${posId}`)
		if (httpOk(menuResponse)) {
			setMenu(menuResponse.data?.menu ?? menuResponse.data?.categories ?? menuResponse.data ?? [])
		}
	}

	useEffect(() => {
		load()
	}, [slug]) // eslint-disable-line react-hooks/exhaustive-deps

	if (!config) {
		return <div className="p-5 text-center">Загрузка...</div>
	}

	const activeBanner = config.banners?.[0] ?? {}
	const categories = Array.isArray(menu) ? menu : []
	const products = categories.flatMap(category => category.products ?? category.children ?? []).slice(0, 8)
	const colors = config.colors ?? {}
	const primaryColor = colors.primary?.default ?? '#e11d48'
	const primaryTextColor = colors.primary?.text ?? '#ffffff'
	const secondaryColor = colors.secondary?.default ?? '#111827'
	const backgroundColor = colors.background?.default ?? '#ffffff'
	const mutedBackgroundColor = colors.background?.muted ?? '#f6f7f9'
	const textColor = colors.text?.default ?? '#111827'
	const mutedTextColor = colors.text?.muted ?? '#6b7280'
	const cardColor = colors.background?.card ?? '#ffffff'

	return (
		<div style={{ background: backgroundColor, color: textColor, minHeight: '100vh' }}>
			<header className="container py-4 d-flex justify-content-between align-items-center">
				<div className="d-flex align-items-center gap-3">
					{!!config.logo && <img src={resolveUploadUrl(config.logo, 'websites')} alt="" style={{ width: 54, height: 54, objectFit: 'contain' }} />}
					<div>
						<h3 className="mb-0">{config.brand_name || config.name}</h3>
						<small>{config.description}</small>
					</div>
				</div>
				<div className="d-flex gap-2">
					{config.languages?.map(language => (
						<span className="badge" style={{ background: mutedBackgroundColor, color: textColor }} key={language.id}>{language.code}</span>
					))}
				</div>
			</header>

			<main className="container pb-5">
				<section
					className="p-5 mb-4"
					style={{
						minHeight: 360,
						borderRadius: 32,
						background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
						backgroundImage: activeBanner.image ? `linear-gradient(90deg, rgba(0,0,0,.65), rgba(0,0,0,.15)), url(${resolveUploadUrl(activeBanner.image, 'websites')})` : undefined,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						// Поверх баннера лежит тёмный градиент, там всегда белый; на чистой
						// заливке берём контрастный к primary цвет из темы (у светлых тем он тёмный).
						color: activeBanner.image ? '#fff' : primaryTextColor,
					}}>
					<div style={{ maxWidth: 560 }}>
						<h1 className="display-5 fw-bold">{activeBanner.title || config.brand_name || config.name}</h1>
						<p className="lead">{activeBanner.subtitle || config.description}</p>
						<button className="btn btn-lg" style={{ background: cardColor, color: textColor }}>{activeBanner.button_text || 'Заказать'}</button>
					</div>
				</section>

				{!!categories.length &&
					<div className="d-flex gap-2 overflow-auto mb-4">
						{categories.map(category => (
							<div className="px-4 py-2" style={{ borderRadius: 999, background: mutedBackgroundColor, color: textColor, whiteSpace: 'nowrap' }} key={category.id ?? category.name}>
								{category.name}
							</div>
						))}
					</div>
				}

				{!!products.length &&
					<section>
						<h2 className="mb-3">Хит продаж</h2>
						<div className="row g-3">
							{products.map(product => (
								<div className="col-6 col-md-4 col-lg-3" key={`${product.id}-${product.name}`}>
									<div className="h-100 p-3 shadow-sm" style={{ borderRadius: 24, background: cardColor, color: textColor }}>
										<div className="mb-3" style={{ height: 160, borderRadius: 16, background: mutedBackgroundColor, backgroundImage: product.image ? `url(${product.image})` : undefined, backgroundSize: 'cover', backgroundPosition: 'center' }} />
										<h5>{product.name}</h5>
										<div className="fw-bold" style={{ color: primaryColor }}>
											{Number(product.sale_price ?? product.price ?? 0).toLocaleString('ru-RU')} сум
										</div>
									</div>
								</div>
							))}
						</div>
					</section>
				}

				{!!config.poses?.length &&
					<section className="mt-5">
						<h2>Филиалы</h2>
						<div className="row g-3">
							{config.poses?.map(pos => (
								<div className="col-md-4" key={pos.id}>
									<div className="p-3 shadow-sm" style={{ borderRadius: 18, background: cardColor, color: textColor }}>
										<b>{pos.name}</b>
										<div style={{ color: mutedTextColor }}>{pos.address}</div>
									</div>
								</div>
							))}
						</div>
					</section>
				}
			</main>
		</div>
	)
}

export default Site
